class Helper {
  constructor() {}

  addtoCartAjax(url, data, cb) {
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      },
      referrer: 'no-referrer'
    }).then(function (response) {
      // The API call was successful!
      if (response.ok) {
        return response.json();
      } else {
        return Promise.reject(response);
      }
    }).then(function (data) {
      // This is the JSON from our response
      if (typeof cb === "function") {
        cb(data);
      }
    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
  }
}